<button class="remove" (click)="remove($event)" [title]="label" [attr.aria-label]="label">
  <img src="./assets/icons/cancel.svg" [alt]="label"/>
</button>